
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Low_Bid_Wf = class Notification_Low_Bid_Wf {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _outbid_modal_init_wf = false;
    static _outbid_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let bid_id = null;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.bid_id) {
                bid_id = meta.bid_id;
            }

        } catch (e) {
        }

        // Button handlers.
        if (!_.Notification_Outbid._outbid_modal_init_wf) {
            _.Notification_Outbid._outbid_modal_init_wf = true;
            $("#ac-modal-low-bid-wf-btn-bid").click(function () {
                _.Notification_Outbid._outbid_modal_action = 'ask';
                _.Modal.close_unhidable({ hide_overlay: false });
            })
            $("#ac-modal-low-bid-wf-btn-close").click(function () {
                _.Modal.close_unhidable();
            })
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                // do {
                _.Notification_Outbid._outbid_modal_action = null;

                let my_bid = await App_Models_Bid.get_private(bid_id);

                if (!my_bid) {
                    _.shouldnt_happen();
                    return;
                }

                let auction_round_id = my_bid.auction_round_id;
                let auction_round = await App_Models_AuctionRound.get_private(auction_round_id);

                // Bid can be deleted if it was a pending bid before it was outbid
                if (!auction_round) {
                    resolve();
                    return;
                }

                $(".ac-modal-low-bid-wf-mybid").text(_.currency(my_bid.amount));
                $("#ac-modal-low-bid-wf-target-bid").text(_.currency(auction_round.enterprise_required_bid_to_be_top_bid));

                let update_outbid_notification_amounts = async function () {
                    $("#ac-modal-low-bid-wf-target-bid").text(_.currency(auction_round.enterprise_required_bid_to_be_top_bid));
                }

                self.auction_round_subscription = await auction_round.subscribe(true, update_outbid_notification_amounts);

                let deferred = $.Deferred();

                $("#ac-modal-low-bid-wf").data('deferred', deferred);

                let item = await auction_round.auction_item.fetch_private();
                $("#ac-modal-low-bid-wf-item").text(item.title);

                $("#ac-modal-low-bid-wf").modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                // Do things
                try {
                    self.auction_round_subscription.unsubscribe();
                } catch (e) { }

                // If they clicked a relevant button, handle it
                if (_.Notification_Outbid._outbid_modal_action == 'ask') {
                    await _.AuctionUI_Bids.try_bid((await auction_round.auction_item.fetch_private()).id, auction_round.ask);
                } else if (_.Notification_Outbid._outbid_modal_action == 'custom') {
                    await _.AuctionUI_Bids.custom_bid_modal(auction_round.auction_item_id);
                }

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
        try {
            self.auction_round_subscription.unsubscribe();
        } catch (e) { }
    }
}